/**
 * Lloyds (LBG) desktop status-screen spacing.
 *
 * The status screens (error, "link unavailable", no-bank) were laid out in
 * `vh`, so they only reproduced the Figma at the artboard's own viewport
 * height and drifted at every other window size. These are the same gaps read
 * back off the desktop Figma as fixed pixels.
 *
 * The frame was scaled using the three fixed-pixel anchors it shares with the
 * app — the 92px header avatar, the 104px error circle inside its 128px SVG
 * box, and the 5vw content gutter, which agree on 0.877 — so the numbers below
 * are the design's own pixels, not the old `vh` values re-expressed.
 *
 * Mobile keeps its own tokens; see the MOBILE_* values in ./mobile.
 */
export const DESKTOP_STATUS = {
  /**
   * Content-column top → the icon. The Figma leaves 26px, and `Message`'s own
   * 24px top padding plus the 12px of transparent padding inside the status
   * SVGs already account for it, so the screens add nothing on top.
   */
  TOP_OFFSET: 0,
  /** Icon → title. */
  ICON_GAP: 20,
  /** Title → the white description card. */
  TITLE_GAP: 24,
  /**
   * Description card → the CTA row, for the status screens that want the
   * Figma's roomy split. Screens whose design butts the CTAs up under the card
   * pass `actionsGap={0}` to `Message` instead.
   */
  ACTIONS_GAP: 48,
  /** Fallback MUI icon when no brand SVG is passed (was `8.5vh`). */
  ICON_SIZE: 72,
};
